import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, CalendarDays } from "lucide-react";
import { FadeIn, HexPattern, Eyebrow } from "../components/reactbits/Anim";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return iso;
  }
};

const BlogDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/blogs/${slug}`);
        setPost(res.data);
        setStatus("ok");
      } catch {
        setStatus("notfound");
      }
    })();
  }, [slug]);

  return (
    <div className="bg-white text-[#1F1B13]" data-testid="blog-detail-page">
      <section className="relative overflow-hidden bg-[#FDFBF7] pt-40 pb-14">
        <HexPattern opacity={0.05} />
        <div className="relative mx-auto max-w-4xl px-6 lg:px-10">
          <Link to="/blogs" className="inline-flex items-center gap-2 text-sm font-semibold text-[#B45309]" data-testid="back-to-blogs">
            <ArrowLeft className="h-4 w-4" /> All posts
          </Link>
          {status === "ok" && post && (
            <>
              <div className="mt-6">
                <Eyebrow>insights</Eyebrow>
              </div>
              <h1 className="mt-5 font-heading text-3xl font-bold leading-tight sm:text-5xl" data-testid="blog-detail-title">
                {post.title}
              </h1>
              <p className="mt-4 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-[#8A8272]">
                <CalendarDays className="h-4 w-4 text-[#E8930C]" /> {fmtDate(post.created_at)}
              </p>
            </>
          )}
          {status === "notfound" && (
            <h1 className="mt-8 font-heading text-3xl font-bold" data-testid="blog-notfound">
              Post not found
            </h1>
          )}
        </div>
      </section>

      {status === "ok" && post && (
        <section className="py-14">
          <div className="mx-auto max-w-4xl px-6 lg:px-10">
            {post.thumbnail && (
              <FadeIn>
                <img src={post.thumbnail} alt={post.title} className="w-full rounded-2xl border border-[#EDE5D3] object-cover" />
              </FadeIn>
            )}
            <FadeIn delay={0.1}>
              <div className="mt-10 space-y-5" data-testid="blog-detail-content">
                {(post.content || post.excerpt || "").split(/\n\s*\n|\n/).filter(Boolean).map((para, i) => (
                  <p key={i} className="text-base leading-relaxed text-[#4A4436]">
                    {para}
                  </p>
                ))}
                {!post.content && post.external_url && (
                  <a href={post.external_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-semibold text-[#B45309]">
                    Read the full article
                  </a>
                )}
              </div>
            </FadeIn>
          </div>
        </section>
      )}
    </div>
  );
};

export default BlogDetail;
